/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
import Vue from 'vue';
import { method, render } from '../lib';
import { VimeHls, VimeFile, VimeVideo } from '@vime/core';
import { define } from '../lib';
define('vime-hls', VimeHls);
define('vime-file', VimeFile);
define('vime-video', VimeVideo);
export default Vue.extend({
    props: {
        version: {},
        config: {},
        crossOrigin: {},
        preload: {},
        poster: {},
        controlsList: {},
        autoPiP: {},
        disablePiP: {},
        disableRemotePlayback: {},
        mediaTitle: {},
    },
    methods: {
        getAdapter: method('getAdapter'),
    },
    render: render('vime-hls', ['vLoadStart']),
});
//# sourceMappingURL=VimeHls.js.map